module.exports = __webpack_public_path__ + "img/empty-img.c2644012.svg";